
import React from "react";
import MainLayout from "@/layout/MainLayout";
import PasswordProtection from "@/components/PasswordProtection";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const Config = () => {
  return (
    <MainLayout>
      <div className="container mx-auto px-6 py-20">
        <PasswordProtection>
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl font-light mb-8">Admin Dashboard</h1>

            <div className="grid gap-6 md:grid-cols-2">
              <Card>
                <CardHeader>
                  <CardTitle>Call Requests</CardTitle>
                  <CardDescription>
                    View all incoming call requests from the website
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <p>
                    Call requests are now being handled automatically by N8N workflows.
                    Check the N8N dashboard for more details on call processing.
                  </p>
                </CardContent>
              </Card>
              
              <Card>
                <CardHeader>
                  <CardTitle>System Status</CardTitle>
                  <CardDescription>
                    Current system configuration and status
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span className="text-muted-foreground">Call Processing</span>
                      <span className="font-medium text-green-500">Active</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-muted-foreground">N8N Integration</span>
                      <span className="font-medium text-green-500">Connected</span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </PasswordProtection>
      </div>
    </MainLayout>
  );
};

export default Config;
